module.exports = __webpack_public_path__ + "static/img/academics-curriculum-structure-24.c8588d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/academics-curriculum-structure-24.png
// module id = qv8h
// module chunks = 1